import { Button, Datepicker, Dropdown, Label, Modal, Select, Table, TableBody, TableCell, TableRow, Textarea, TextInput } from "flowbite-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import moment from "moment";
import { getBrands } from "../../api/brands";
import OverlayPreloader from "../preloaders/OverlayPreloader";
import { createCampaign } from "../../api/campaigns";
import { getAgencies, getAgencyManagers } from "../../api/agencies";
import getUnicodeFlagIcon from 'country-flag-icons/unicode';
import ReactSelect from "react-select";
import ISO6391 from "iso-639-1";
import { HiMinus, HiPlus } from "react-icons/hi";

const CreateModal = ({ openModal, setOpenModal, lists, fetchCampaigns, campaignToEdit }) => {
  const industries = ['Crypto Trading', 'Online Casino', 'E-commerce', 'Other'];
  const campaignObjectives = ['Brand Awareness', 'Lead Generation', 'Sales & Conversions', 'Other'];
  const collaborationTypes = ['Sponsored Post', 'Product Review', 'Shoutout', 'Ad Integration', 'Other'];
  const contentFormats = ['Instagram Stories', 'YouTube Integration', 'TikTok Video', 'Twitter Post', 'Other'];
  const proposedPayments = ['£', '$', '€', 'Other'];
  const paymentTermsOptions = ['Fixed Price', 'Negotiable', 'Perfrormance-Based'];
  const paymentMethods = ['Bank Transfer', 'PayPal', 'Crypto'];
  const [followUpSchema, setFollowUpSchema] = useState([1]);
  const [delayFlowResult, setDelayFlowResult] = useState('1 day');

  const scheduleTime = Array.from({ length: 24 }, (_, i) => ({
    label: `${i === 0 ? 12 : i > 12 ? i - 12 : i}${i < 12 ? 'AM' : 'PM'}`,
    value: `${String(i).padStart(2, '0')}:00`,
  }));

  const [formData, setFormData] = useState({
    brandId: '',
    agencyId: '',
    listId: '',
    industry: '',
    campaignObjective: '',
    collaborationType: '',
    contentFormat: '',
    numberOfDeliverables: '',
    contentGuidelines: '',
    proposedPayment: '',
    paymentTerms: '',
    paymentMethod: [],
    deadline: '',
    additionalNotes: '',
    profileId: '',
    flowType: '',
    delayFlow: '',
    language: 'en',
    geo: 'GB',
    startDate: '',
    endDate: '',
    sendEmailOnDays: [],
    sendBetweenFrom: '',
    sendBetweenTo: '',
  });

  const countries = [
    { name: 'Afghanistan', code: 'AF' },
    { name: 'Åland Islands', code: 'AX' },
    { name: 'Albania', code: 'AL' },
    { name: 'Algeria', code: 'DZ' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'AndorrA', code: 'AD' },
    { name: 'Angola', code: 'AO' },
    { name: 'Anguilla', code: 'AI' },
    { name: 'Antarctica', code: 'AQ' },
    { name: 'Antigua and Barbuda', code: 'AG' },
    { name: 'Argentina', code: 'AR' },
    { name: 'Armenia', code: 'AM' },
    { name: 'Aruba', code: 'AW' },
    { name: 'Australia', code: 'AU' },
    { name: 'Austria', code: 'AT' },
    { name: 'Azerbaijan', code: 'AZ' },
    { name: 'Bahamas', code: 'BS' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Bangladesh', code: 'BD' },
    { name: 'Barbados', code: 'BB' },
    { name: 'Belarus', code: 'BY' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Belize', code: 'BZ' },
    { name: 'Benin', code: 'BJ' },
    { name: 'Bermuda', code: 'BM' },
    { name: 'Bhutan', code: 'BT' },
    { name: 'Bolivia', code: 'BO' },
    { name: 'Bosnia and Herzegovina', code: 'BA' },
    { name: 'Botswana', code: 'BW' },
    { name: 'Bouvet Island', code: 'BV' },
    { name: 'Brazil', code: 'BR' },
    { name: 'British Indian Ocean Territory', code: 'IO' },
    { name: 'Brunei Darussalam', code: 'BN' },
    { name: 'Bulgaria', code: 'BG' },
    { name: 'Burkina Faso', code: 'BF' },
    { name: 'Burundi', code: 'BI' },
    { name: 'Cambodia', code: 'KH' },
    { name: 'Cameroon', code: 'CM' },
    { name: 'Canada', code: 'CA' },
    { name: 'Cape Verde', code: 'CV' },
    { name: 'Cayman Islands', code: 'KY' },
    { name: 'Central African Republic', code: 'CF' },
    { name: 'Chad', code: 'TD' },
    { name: 'Chile', code: 'CL' },
    { name: 'China', code: 'CN' },
    { name: 'Christmas Island', code: 'CX' },
    { name: 'Cocos (Keeling) Islands', code: 'CC' },
    { name: 'Colombia', code: 'CO' },
    { name: 'Comoros', code: 'KM' },
    { name: 'Congo', code: 'CG' },
    { name: 'Congo, The Democratic Republic of the', code: 'CD' },
    { name: 'Cook Islands', code: 'CK' },
    { name: 'Costa Rica', code: 'CR' },
    { name: 'Cote D\'Ivoire', code: 'CI' },
    { name: 'Croatia', code: 'HR' },
    { name: 'Cuba', code: 'CU' },
    { name: 'Cyprus', code: 'CY' },
    { name: 'Czech Republic', code: 'CZ' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Djibouti', code: 'DJ' },
    { name: 'Dominica', code: 'DM' },
    { name: 'Dominican Republic', code: 'DO' },
    { name: 'Ecuador', code: 'EC' },
    { name: 'Egypt', code: 'EG' },
    { name: 'El Salvador', code: 'SV' },
    { name: 'Equatorial Guinea', code: 'GQ' },
    { name: 'Eritrea', code: 'ER' },
    { name: 'Estonia', code: 'EE' },
    { name: 'Ethiopia', code: 'ET' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK' },
    { name: 'Faroe Islands', code: 'FO' },
    { name: 'Fiji', code: 'FJ' },
    { name: 'Finland', code: 'FI' },
    { name: 'France', code: 'FR' },
    { name: 'French Guiana', code: 'GF' },
    { name: 'French Polynesia', code: 'PF' },
    { name: 'French Southern Territories', code: 'TF' },
    { name: 'Gabon', code: 'GA' },
    { name: 'Gambia', code: 'GM' },
    { name: 'Georgia', code: 'GE' },
    { name: 'Germany', code: 'DE' },
    { name: 'Ghana', code: 'GH' },
    { name: 'Gibraltar', code: 'GI' },
    { name: 'Greece', code: 'GR' },
    { name: 'Greenland', code: 'GL' },
    { name: 'Grenada', code: 'GD' },
    { name: 'Guadeloupe', code: 'GP' },
    { name: 'Guam', code: 'GU' },
    { name: 'Guatemala', code: 'GT' },
    { name: 'Guernsey', code: 'GG' },
    { name: 'Guinea', code: 'GN' },
    { name: 'Guinea-Bissau', code: 'GW' },
    { name: 'Guyana', code: 'GY' },
    { name: 'Haiti', code: 'HT' },
    { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
    { name: 'Holy See (Vatican City State)', code: 'VA' },
    { name: 'Honduras', code: 'HN' },
    { name: 'Hong Kong', code: 'HK' },
    { name: 'Hungary', code: 'HU' },
    { name: 'Iceland', code: 'IS' },
    { name: 'India', code: 'IN' },
    { name: 'Indonesia', code: 'ID' },
    { name: 'Iran, Islamic Republic Of', code: 'IR' },
    { name: 'Iraq', code: 'IQ' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Isle of Man', code: 'IM' },
    { name: 'Israel', code: 'IL' },
    { name: 'Italy', code: 'IT' },
    { name: 'Jamaica', code: 'JM' },
    { name: 'Japan', code: 'JP' },
    { name: 'Jersey', code: 'JE' },
    { name: 'Jordan', code: 'JO' },
    { name: 'Kazakhstan', code: 'KZ' },
    { name: 'Kenya', code: 'KE' },
    { name: 'Kiribati', code: 'KI' },
    { name: 'Korea, Democratic People\'S Republic of', code: 'KP' },
    { name: 'Korea, Republic of', code: 'KR' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', code: 'KG' },
    { name: 'Lao People\'S Democratic Republic', code: 'LA' },
    { name: 'Latvia', code: 'LV' },
    { name: 'Lebanon', code: 'LB' },
    { name: 'Lesotho', code: 'LS' },
    { name: 'Liberia', code: 'LR' },
    { name: 'Libyan Arab Jamahiriya', code: 'LY' },
    { name: 'Liechtenstein', code: 'LI' },
    { name: 'Lithuania', code: 'LT' },
    { name: 'Luxembourg', code: 'LU' },
    { name: 'Macao', code: 'MO' },
    { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
    { name: 'Madagascar', code: 'MG' },
    { name: 'Malawi', code: 'MW' },
    { name: 'Malaysia', code: 'MY' },
    { name: 'Maldives', code: 'MV' },
    { name: 'Mali', code: 'ML' },
    { name: 'Malta', code: 'MT' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Martinique', code: 'MQ' },
    { name: 'Mauritania', code: 'MR' },
    { name: 'Mauritius', code: 'MU' },
    { name: 'Mayotte', code: 'YT' },
    { name: 'Mexico', code: 'MX' },
    { name: 'Micronesia, Federated States of', code: 'FM' },
    { name: 'Moldova, Republic of', code: 'MD' },
    { name: 'Monaco', code: 'MC' },
    { name: 'Mongolia', code: 'MN' },
    { name: 'Montserrat', code: 'MS' },
    { name: 'Morocco', code: 'MA' },
    { name: 'Mozambique', code: 'MZ' },
    { name: 'Myanmar', code: 'MM' },
    { name: 'Namibia', code: 'NA' },
    { name: 'Nauru', code: 'NR' },
    { name: 'Nepal', code: 'NP' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'Netherlands Antilles', code: 'AN' },
    { name: 'New Caledonia', code: 'NC' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'Nicaragua', code: 'NI' },
    { name: 'Niger', code: 'NE' },
    { name: 'Nigeria', code: 'NG' },
    { name: 'Niue', code: 'NU' },
    { name: 'Norfolk Island', code: 'NF' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Norway', code: 'NO' },
    { name: 'Oman', code: 'OM' },
    { name: 'Pakistan', code: 'PK' },
    { name: 'Palau', code: 'PW' },
    { name: 'Palestinian Territory, Occupied', code: 'PS' },
    { name: 'Panama', code: 'PA' },
    { name: 'Papua New Guinea', code: 'PG' },
    { name: 'Paraguay', code: 'PY' },
    { name: 'Peru', code: 'PE' },
    { name: 'Philippines', code: 'PH' },
    { name: 'Pitcairn', code: 'PN' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Reunion', code: 'RE' },
    { name: 'Romania', code: 'RO' },
    { name: 'Russian Federation', code: 'RU' },
    { name: 'RWANDA', code: 'RW' },
    { name: 'Saint Helena', code: 'SH' },
    { name: 'Saint Kitts and Nevis', code: 'KN' },
    { name: 'Saint Lucia', code: 'LC' },
    { name: 'Saint Pierre and Miquelon', code: 'PM' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC' },
    { name: 'Samoa', code: 'WS' },
    { name: 'San Marino', code: 'SM' },
    { name: 'Sao Tome and Principe', code: 'ST' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Senegal', code: 'SN' },
    { name: 'Serbia and Montenegro', code: 'CS' },
    { name: 'Seychelles', code: 'SC' },
    { name: 'Sierra Leone', code: 'SL' },
    { name: 'Singapore', code: 'SG' },
    { name: 'Slovakia', code: 'SK' },
    { name: 'Slovenia', code: 'SI' },
    { name: 'Solomon Islands', code: 'SB' },
    { name: 'Somalia', code: 'SO' },
    { name: 'South Africa', code: 'ZA' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { name: 'Spain', code: 'ES' },
    { name: 'Sri Lanka', code: 'LK' },
    { name: 'Sudan', code: 'SD' },
    { name: 'Suriname', code: 'SR' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ' },
    { name: 'Swaziland', code: 'SZ' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Syrian Arab Republic', code: 'SY' },
    { name: 'Taiwan, Province of China', code: 'TW' },
    { name: 'Tajikistan', code: 'TJ' },
    { name: 'Tanzania, United Republic of', code: 'TZ' },
    { name: 'Thailand', code: 'TH' },
    { name: 'Timor-Leste', code: 'TL' },
    { name: 'Togo', code: 'TG' },
    { name: 'Tokelau', code: 'TK' },
    { name: 'Tonga', code: 'TO' },
    { name: 'Trinidad and Tobago', code: 'TT' },
    { name: 'Tunisia', code: 'TN' },
    { name: 'Turkey', code: 'TR' },
    { name: 'Turkmenistan', code: 'TM' },
    { name: 'Turks and Caicos Islands', code: 'TC' },
    { name: 'Tuvalu', code: 'TV' },
    { name: 'Uganda', code: 'UG' },
    { name: 'Ukraine', code: 'UA' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'United States', code: 'US' },
    { name: 'United States Minor Outlying Islands', code: 'UM' },
    { name: 'Uruguay', code: 'UY' },
    { name: 'Uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', code: 'VU' },
    { name: 'Venezuela', code: 'VE' },
    { name: 'Viet Nam', code: 'VN' },
    { name: 'Virgin Islands, British', code: 'VG' },
    { name: 'Virgin Islands, U.S.', code: 'VI' },
    { name: 'Wallis and Futuna', code: 'WF' },
    { name: 'Western Sahara', code: 'EH' },
    { name: 'Yemen', code: 'YE' },
    { name: 'Zambia', code: 'ZM' },
    { name: 'Zimbabwe', code: 'ZW' }
  ];

  const languageCodesAndFlags = [
    {
      code: 'en',
      flag: 'US',
    },
    {
      code: 'it',
      flag: 'IT',
    },
    {
      code: 'fr',
      flag: 'FR',
    },
    {
      code: 'es',
      flag: 'ES',
    },
    {
      code: 'de',
      flag: 'DE',
    },
    {
      code: 'pt',
      flag: 'PT',
    },
    {
      code: 'nl',
      flag: 'NL',
    },
    {
      code: 'sv',
      flag: 'SE',
    },
    {
      code: 'da',
      flag: 'DK',
    },
    {
      code: 'no',
      flag: 'NO',
    },
    {
      code: 'fi',
      flag: 'FI',
    },
    {
      code: 'pl',
      flag: 'PL',
    },
    {
      code: 'ru',
      flag: 'RU',
    },
    {
      code: 'zh',
      flag: 'CN',
    },
    {
      code: 'ja',
      flag: 'JP',
    },
    {
      code: 'ko',
      flag: 'KR',
    },
    {
      code: 'ar',
      flag: 'AE',
    },
    {
      code: 'he',
      flag: 'IL',
    },
    {
      code: 'tr',
      flag: 'TR',
    },
    {
      code: 'el',
      flag: 'GR',
    }
  ];

  let languages = {};

  languageCodesAndFlags.map(lang => {
    languages[lang.code] = {
      flag: lang.flag,
      name: ISO6391.getName(lang.code),
    };

    return true;
  });

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [agencies, setAgencies] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [isGeneratingSubject, setIsGeneratingSubject] = useState(false);

  useEffect(() => {
    const fetchBrands = async () => {
      setLoadingData(true);

      try {
        const _brands = await getBrands({ all: true });

        if (_brands.brands.length) {
          setBrands(_brands.brands);
        }
      } catch (error) {
        console.error(error);
        toast.error('Error fetching brands');
      } finally {
        setLoadingData(false);
      }
    }

    const fetchAgencies = async () => {
      try {
        const _agencies = await getAgencies({ all: true });

        if (_agencies.agencies.length) {
          setAgencies(_agencies.agencies);
        }
      } catch (error) {
        console.error(error);
        toast.error('Error fetching agencies');
      }
    }

    if (openModal) {
      fetchBrands();
      fetchAgencies();
    }
  }, [openModal]);

  const handleChange = async (e) => {
    const { name, value } = e.target;

    if (name === 'agencyId') {
      const managers = await getAgencyManagers(value);

      setProfiles(managers);
    }

    setFormData((prevData) => ({ ...prevData, [name]: value }));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      await createCampaign({
        ...formData,
        type: 'instagram',
        data: 'modash',
      });

      toast.success(`Campaign has been created successfully`);
      fetchCampaigns();
      setOpenModal(false);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || error.message || 'Failed to create campaign');
    } finally {
      setLoading(false);
    }
  }

  const handleGenerateSubject = () => {
    setIsGeneratingSubject(true);

    try {
      // TODO: Implement real subject generation

      setFormData((prevData) => ({
        ...prevData,
        subjectLine: 'Test subject line',
      }));
    } catch (error) {
      console.error(error);
      toast.error('Failed to generate subject');
    } finally {
      setIsGeneratingSubject(false);
    }
  }

  const handleAddItem = () => setFollowUpSchema(prevSchema => [...prevSchema, 1]);
  const handleRemoveItem = (key) => setFollowUpSchema(prevSchema => prevSchema.filter((_, index) => index !== key));

  const convertArrayToText = arr => {
    let totalDays = arr.filter(item => !isNaN(item)).reduce((sum, num) => sum + Number(num), 0);
    let repeatText = '';

    if (arr.includes('weekly-repeat')) {
      repeatText = ' + ongoing weekly';
    } else if (arr.includes('monthly-repeat')) {
      repeatText = ' + ongoing monthly';
    }

    return `${totalDays} days${repeatText}`;
  }

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      delayFlow: followUpSchema.join(','),
    }));

    setDelayFlowResult(convertArrayToText(followUpSchema));
  }, [followUpSchema]);

  return (
    <Modal
      show={openModal}
      size={step === 1 ? 'md' : '5xl'}
      onClose={() => setOpenModal(false)}
      popup
      theme={{
        body: {
          base: 'flex-1 p-6 pt-0 h-full overflow-auto',
        }
      }}
    >
      <Modal.Header />
      <Modal.Body>
        <h3 className="text-xl font-medium text-gray-900 mb-4">Create campaign</h3>
        {step === 1 ? (
          <>
            <p className="text-gray-500 dark:text-gray-400 my-4">Select your campaign type</p>
            <ul className="space-y-4 mb-4">
              <li>
                <input
                  type="radio"
                  id="flowTypeManual"
                  name="flowType"
                  value="manual"
                  className="hidden peer"
                  required
                  onChange={e => {
                    handleChange(e);
                    setStep(2);
                  }}
                />
                <label htmlFor="flowTypeManual" className="inline-flex items-center justify-between w-full p-5 text-gray-900 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 dark:border-gray-500 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 dark:peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-900 hover:bg-gray-100 dark:text-white dark:bg-gray-600 dark:hover:bg-gray-500">
                  <div className="block">
                    <div className="w-full text-lg font-semibold">Manual campaign</div>
                    <div className="w-full text-gray-500 dark:text-gray-400">Messages are only sent when send button is triggered</div>
                  </div>
                  <svg className="size-4 ms-3 rtl:rotate-180 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9" /></svg>
                </label>
              </li>
              <li>
                <input
                  type="radio"
                  id="flowTypeAutomated"
                  name="flowType"
                  value="automated"
                  className="hidden peer"
                  required
                  onChange={e => {
                    handleChange(e);
                    setStep(2);
                  }}
                />
                <label htmlFor="flowTypeAutomated" className="inline-flex items-center justify-between w-full p-5 text-gray-900 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 dark:border-gray-500 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 dark:peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-900 hover:bg-gray-100 dark:text-white dark:bg-gray-600 dark:hover:bg-gray-500">
                  <div className="block">
                    <div className="w-full text-lg font-semibold">Automated campaign</div>
                    <div className="w-full text-gray-500 dark:text-gray-400">Messages will be sent automatically through preconfigured workflow</div>
                  </div>
                  <svg className="size-4 ms-3 rtl:rotate-180 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9" /></svg>
                </label>
              </li>
            </ul>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6 relative">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
              <div>
                <div className="mb-2 block">
                  <Label htmlFor="brand" value="Brand" />
                </div>
                <Select
                  id="brandId"
                  name="brandId"
                  value={formData.brandId}
                  onChange={handleChange}
                  required
                >
                  <option
                    value=""
                    disabled
                  >
                    Select
                  </option>
                  {brands.map((brand) => (
                    <option key={brand._id} value={brand._id}>
                      {brand.name}
                    </option>
                  ))}
                </Select>
              </div>

              <div className="flex gap-2">
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="language" value="Language" />
                  </div>
                  <Dropdown
                    arrowIcon={false}
                    inline
                    label={
                      <div
                        className="inline-flex items-center font-medium justify-center px-4 py-2 text-sm text-gray-900 dark:text-white rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-white"
                      >
                        <div className="me-3">{getUnicodeFlagIcon(languages[Object.keys(languages).find(key => key === formData.language)].flag)}</div>
                        {ISO6391.getName(formData.language)}
                      </div>
                    }
                    theme={{
                      floating: {
                        base: 'z-10 w-fit divide-y divide-gray-100 rounded shadow focus:outline-none transition-opacity duration-100 border border-gray-200 bg-white text-gray-900 dark:border-none dark:bg-gray-700 dark:text-white overflow-auto max-h-96',
                      },
                    }}
                  >
                    {Object.keys(languages).map(key => (
                      <Dropdown.Item
                        key={key}
                        onClick={() => {
                          handleChange({
                            target: {
                              name: 'language',
                              value: key,
                            }
                          })
                        }}
                      >
                        <div className="inline-flex items-center">
                          <div className="me-2">{getUnicodeFlagIcon(languages[key].flag)}</div>
                          <span className="whitespace-nowrap">{languages[key].name}</span>
                        </div>
                      </Dropdown.Item>
                    ))}
                  </Dropdown>
                </div>

                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="geo" value="Geo" />
                  </div>
                  <Dropdown
                    arrowIcon={false}
                    inline
                    label={
                      <div
                        className="inline-flex items-center font-medium justify-center px-4 py-2 text-sm text-gray-900 dark:text-white rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-white"
                      >
                        <div className="me-3">{getUnicodeFlagIcon(formData.geo)}</div>
                        {countries.find(value => value.code === formData.geo).name}
                      </div>
                    }
                    theme={{
                      floating: {
                        base: 'z-10 w-fit divide-y divide-gray-100 rounded shadow focus:outline-none transition-opacity duration-100 border border-gray-200 bg-white text-gray-900 dark:border-none dark:bg-gray-700 dark:text-white overflow-auto max-h-96',
                      },
                    }}
                  >
                    {countries.map(key => (
                      <Dropdown.Item
                        key={key.code}
                        onClick={() => {
                          handleChange({
                            target: {
                              name: 'geo',
                              value: key.code,
                            }
                          })
                        }}
                      >
                        <div className="inline-flex items-center">
                          <div className="me-2">{getUnicodeFlagIcon(key.code)}</div>
                          <span className="whitespace-nowrap">{countries.find(value => value.code === key.code).name}</span>
                        </div>
                      </Dropdown.Item>
                    ))}
                  </Dropdown>
                </div>
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="startDate" value="Start Date" />
                </div>
                <Datepicker
                  id="startDate"
                  name="startDate"
                  value={formData.startDate || ''}
                  onSelectedDateChanged={value => {
                    handleChange({
                      target: {
                        name: 'startDate',
                        value: moment(value).format('YYYY-MM-DD'),
                      },
                    });
                  }}
                  required
                  minDate={new Date()}
                  weekStart={1}
                />
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="deadline" value="End Date" />
                </div>
                <Datepicker
                  id="deadline"
                  name="deadline"
                  value={formData.deadline || ''}
                  onSelectedDateChanged={value => {
                    handleChange({
                      target: {
                        name: 'deadline',
                        value: moment(value).format('YYYY-MM-DD'),
                      },
                    });
                  }}
                  required
                  minDate={formData.startDate ? new Date(formData.startDate) : new Date()}
                  weekStart={1}
                />
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="industry" value="Industry" />
                </div>
                <Select
                  id="industry"
                  name="industry"
                  value={formData.industry}
                  onChange={handleChange}
                >
                  <option
                    value=""
                    disabled
                  >
                    Select
                  </option>
                  {industries.map((industry) => (
                    <option key={industry} value={industry}>
                      {industry}
                    </option>
                  ))}
                </Select>
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="campaignObjective" value="Campaign Objective" />
                </div>
                <Select
                  id="campaignObjective"
                  name="campaignObjective"
                  value={formData.campaignObjective}
                  onChange={handleChange}
                >
                  <option
                    value=""
                    disabled
                  >
                    Select
                  </option>
                  {campaignObjectives.map((campaignObjective) => (
                    <option key={campaignObjective} value={campaignObjective}>
                      {campaignObjective}
                    </option>
                  ))}
                </Select>
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="collaborationType" value="Collaboration Type" />
                </div>
                <Select
                  id="collaborationType"
                  name="collaborationType"
                  value={formData.collaborationType}
                  onChange={handleChange}
                >
                  <option
                    value=""
                    disabled
                  >
                    Select
                  </option>
                  {collaborationTypes.map((collaborationType) => (
                    <option key={collaborationType} value={collaborationType}>
                      {collaborationType}
                    </option>
                  ))}
                </Select>
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="contentFormat" value="Content Format" />
                </div>
                <Select
                  id="contentFormat"
                  name="contentFormat"
                  value={formData.contentFormat}
                  onChange={handleChange}
                >
                  <option
                    value=""
                    disabled
                  >
                    Select
                  </option>
                  {contentFormats.map((contentFormat) => (
                    <option key={contentFormat} value={contentFormat}>
                      {contentFormat}
                    </option>
                  ))}
                </Select>
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="numberOfDeliverables" value="Number Of Deliverables" />
                </div>
                <TextInput
                  type="number"
                  id="numberOfDeliverables"
                  name="numberOfDeliverables"
                  value={formData.numberOfDeliverables}
                  onChange={handleChange}
                />
              </div>

              {/* <div>
                <div className="mb-2 block">
                  <Label htmlFor="deadline" value="Deadline" />
                </div>
                <Datepicker
                  id="deadline"
                  name="deadline"
                  value={formData.deadline ? moment(formData.deadline).format('YYYY-MM-DD') : ''}
                  onSelectedDateChanged={value => {
                    handleChange({
                      target: {
                        name: 'deadline',
                        value,
                      }
                    })
                  }}
                  required
                  minDate={new Date()}
                  weekStart={1}
                />
              </div> */}

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="listId" value="Select list" />
                </div>
                <Select
                  id="listId"
                  name="listId"
                  value={formData.listId}
                  onChange={handleChange}
                  required
                >
                  <option
                    value=""
                    disabled
                  >
                    Select
                  </option>
                  {lists.map((list) => (
                    <option key={list._id} value={list._id}>
                      {list.name}
                    </option>
                  ))}
                </Select>
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="proposedPayment" value="Proposed Payment" />
                </div>
                <Select
                  id="proposedPayment"
                  name="proposedPayment"
                  value={formData.proposedPayment}
                  onChange={handleChange}
                >
                  <option
                    value=""
                    disabled
                  >
                    Select
                  </option>
                  {proposedPayments.map((proposedPayment) => (
                    <option key={proposedPayment} value={proposedPayment}>
                      {proposedPayment}
                    </option>
                  ))}
                </Select>
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="paymentTerms" value="Payment Terms" />
                </div>
                <Select
                  id="paymentTerms"
                  name="paymentTerms"
                  value={formData.paymentTerms}
                  onChange={handleChange}
                >
                  <option
                    value=""
                    disabled
                  >
                    Select
                  </option>
                  {paymentTermsOptions.map((paymentTerm) => (
                    <option key={paymentTerm} value={paymentTerm}>
                      {paymentTerm}
                    </option>
                  ))}
                </Select>
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="contentGuidelines" value="Content Guidelines" />
                </div>
                <Textarea
                  id="contentGuidelines"
                  name="contentGuidelines"
                  value={formData.contentGuidelines}
                  onChange={handleChange}
                />
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="additionalNotes" value="Additional Notes" />
                </div>
                <Textarea
                  id="additionalNotes"
                  name="additionalNotes"
                  value={formData.additionalNotes}
                  onChange={handleChange}
                />
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="subjectLine" value="Subject Line" />
                </div>
                <Textarea
                  id="subjectLine"
                  name="subjectLine"
                  value={formData.subjectLine}
                  onChange={handleChange}
                  required
                />
                <Button
                  className="mt-2"
                  size="xs"
                  color="light"
                  disabled={isGeneratingSubject}
                  isProcessing={isGeneratingSubject}
                  onClick={handleGenerateSubject}
                >
                  Generate
                </Button>
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="paymentMethod" value="Payment Method" />
                </div>

                <ReactSelect
                  isMulti
                  onChange={value => {
                    handleChange({
                      target: {
                        name: 'paymentMethod',
                        value: value.map(v => v.value),
                      },
                    })
                  }}
                  className="text-xs"
                  options={paymentMethods.map(paymentMethod => ({
                    value: paymentMethod,
                    label: paymentMethod,
                  }))}
                  defaultValue={campaignToEdit ? paymentMethods.filter(paymentMethod => campaignToEdit.paymentMethod.includes(paymentMethod._id)).map(paymentMethod => ({
                    value: paymentMethod,
                    label: paymentMethod
                  })) : null}
                />
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="agencyId" value="Agency" />
                </div>
                <Select
                  id="agencyId"
                  name="agencyId"
                  value={formData.agencyId}
                  onChange={handleChange}
                  required
                >
                  <option
                    value=""
                    disabled
                  />
                  {agencies.map((agency) => (
                    <option key={agency._id} value={agency._id}>
                      {agency.name}
                    </option>
                  ))}
                </Select>
              </div>

              <div>
                <div className="mb-2 block">
                  <Label htmlFor="profileId" value="Manager" />
                </div>
                <Select
                  id="profileId"
                  name="profileId"
                  value={formData.profileId}
                  onChange={handleChange}
                  required
                >
                  <option
                    value=""
                    disabled
                  />
                  {profiles.map((profile) => (
                    <option key={profile._id} value={profile._id}>
                      {profile.name}
                    </option>
                  ))}
                </Select>
              </div>
            </div>

            {formData.flowType === 'automated' && (
              <>
                <h3 className="text-xl font-medium text-gray-900 mb-4">Automated Settings</h3>

                <div className="overflow-x-auto">
                  <Table>
                    <TableBody className="divide-y">
                      {followUpSchema.map((item, key) => (
                        <TableRow
                          className="bg-white dark:border-gray-700 dark:bg-gray-800"
                          key={key}
                        >
                          <TableCell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">Step {key + 1}</TableCell>
                          <TableCell>
                            <Select
                              value={item}
                              onChange={e =>
                                setFollowUpSchema(prevSchema =>
                                  prevSchema.map((value, index) =>
                                    index === key ? e.target.value : value
                                  )
                                )
                              }
                            >
                              <option value="1">1 day</option>
                              <option value="2">2 days</option>
                              <option value="3">3 days</option>
                              <option value="5">5 days</option>
                              <option value="10">10 days</option>
                              <option value="30">30 days</option>
                              <option value="weekly-repeat">Every week</option>
                              <option value="monthly-repeat">Every month</option>
                            </Select>
                          </TableCell>
                          <TableCell>
                            <div className="flex gap-2">
                              <Button onClick={handleAddItem}>
                                <HiPlus />
                              </Button>
                              {key > 0 && (
                                <Button
                                  color="red"
                                  onClick={() => handleRemoveItem(key)}
                                >
                                  <HiMinus />
                                </Button>
                              )}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <div>Total: {delayFlowResult}</div>
                </div>
                <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                  <div>
                    <div className="mb-2 block">
                      <Label htmlFor="sendEmailOnDays" value="Send email on days" />
                    </div>

                    <ReactSelect
                      isMulti
                      onChange={value => {
                        handleChange({
                          target: {
                            name: 'sendEmailOnDays',
                            value: value.map(v => v.value),
                          },
                        })
                      }}
                      className="text-xs"
                      options={[
                        {
                          value: 'weekdays',
                          label: 'Weekdays',
                        },
                        {
                          value: 'weekends',
                          label: 'Weekends',
                        },
                      ]}
                    />
                  </div>

                  <div>
                    <div className="mb-2 block">
                      <Label htmlFor="sendEmailOnDays" value="Send between" />
                    </div>
                    <div className="flex gap-2">
                      <Select
                        name="sendBetweenFrom"
                        value={formData.sendBetweenFrom}
                        onChange={handleChange}
                      >
                        {scheduleTime.map(time => (
                          <option
                            key={time.value}
                            value={time.value}
                          >
                            {time.label}
                          </option>
                        ))}
                      </Select>
                      <Select
                        name="sendBetweenTo"
                        value={formData.sendBetweenTo}
                        onChange={handleChange}
                      >
                        {scheduleTime.map(time => (
                          <option
                            key={time.value}
                            value={time.value}
                          >
                            {time.label}
                          </option>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="w-full flex items-center justify-between">
              <Button
                color="gray"
                onClick={() => setStep(1)}
              >
                Go Back
              </Button>
              <Button
                type="submit"
                isProcessing={loading}
                disabled={loading}
              >
                Create
              </Button>
            </div>
            {loadingData && <OverlayPreloader />}
          </form>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default CreateModal;
